import styled from 'styled-components'

export const Content = styled.p`
  ${({ font }) => font && `font-family: ${font};`}
  ${({ color }) => color && `color: ${color};`}
  font-size: 16px;
  line-height: 21px;
  min-height: 21px;
`
